<template>
  <div>
  <el-dialog
    :visible.sync="info.show"
    :close-on-click-modal="false"
    width="800px"
    :modal="false"
    @close="closeAdvanced"
  >
    <el-tabs v-model="selectType" @tab-click="getInvitedList">
      <el-tab-pane :label="$t('coHost.addCoHost')" name="invitedOther">
        <div class="inviteBox" >
          <div class="userListBox">
            <i class="el-icon-user-solid"></i>
            <el-input  @keyup.enter.native="saveCoHost" :class="{redBorder: showErrorEmailText}" :placeholder="$t('coHost.inviteCohoster')" ref="emailInput" @input="checkInputText" v-model="coHostSearchName" clearable></el-input>
            <el-button  @click="saveCoHost">{{$t('coHost.adds')}}</el-button>
          </div>
          <div v-if="showErrorEmailText" class="redColor emailWarn">* {{$t('coHost.emailCorrectly')}}</div>
          <div class="hadInviteList scrollbar" v-scroll="cohostScroll">
            <!--已经有的人-->
            <div class="li" v-for="(user, index) in hadInviteCohost" :key="user.collaborateEmail">
              <!--名字开头-->
              <span class="firstName" :style="{'background':user.color}">{{ user.collaborateEmail? user.collaborateEmail.slice(0, 1) : '' }}</span>
              <!--邮箱-->
              <span class="emailContent" :class="{declined: user.status === 2}">{{ user.collaborateEmail }}</span>
              <!--'邀请中'悬浮文字提示-->
              <el-tooltip class="item" effect="dark" :content="$t('coHost.pending')" placement="top-start">
                <span class="right" v-if="user.status === 0" style="margin-left: 15px;color: #909090;">{{ $t("coHost.inviting") }}</span>
              </el-tooltip>
              <!--拒绝文案-->
              <span class="right" v-if="user.status === 2" style="margin-left: 15px;color: #909090;">{{ $t("coHost.declined") }}</span>
              <!--移除按钮-->
              <el-popover
                placement="bottom-start"
                width="200"
                trigger="hover"
                popper-class="remove"
                >
                <i class="el-icon-more right" slot="reference"></i>
                <span class="pointer" @click="deleteCohostInvite(user.collaborateUserId, index)">{{$t('coHost.remove')}}</span>
              </el-popover>
            </div>
            <div class="loading-txt" v-if="cohostScroll.loading">
              <i class="el-icon-loading" style="color:#909090;"></i>
                {{$t('eventList.loading')}}
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('coHost.receivedCohost')" name="invitedByOther">
        <el-table
          v-scroll="receiverCohostScroll"
          :data="invitedMeList"
          style="width: 100%;margin-top:-18px;"
          class="invitedMe"
          :default-sort = "{prop: 'date', order: 'descending'}"
          >
          <el-table-column
            prop="userEmail"
            label=""
            width="60"
            >
            <template slot-scope="scope">
              <div class="participant firstName" :class="scope.row.color">{{ scope.row.userEmail ? scope.row.userEmail.slice(0, 1) : '' }}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="userEmail"
            :label="$t('coHost.applicant')"
            width="250"
            >
            <template slot-scope="scope">
              <div class="email" :class="{decline: scope.row.status == '2'}" :title="scope.row.userEmail">{{ scope.row.userEmail }}</div>
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="createTime"
            width="180"
            :label="$t('coHost.inviteationTime')">
            <template slot-scope="scope">
              <div>{{ showInvitedTime(scope.row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            width="180"
            :label="$t('coHost.Permission')">
            <template slot-scope="scope">
              <span :class="{pedding: scope.row.status == '0'}">{{ returnText(scope.row) }}</span>
              <el-select popper-class="permission" v-model="scope.row.select" @change="(result) => {controlPermission(result, scope.row)}">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="$t(`coHost.${item.label}`)"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            label="">
            <template slot-scope="scope">
              <el-popover
                placement="bottom-start"
                width="200"
                trigger="hover"
                popper-class="remove">
                <i class="el-icon-more right pointer" slot="reference"></i>
                <span class="pointer" @click="deleteCollaborateByOtherInvite(scope.row)">{{$t('coHost.remove')}}</span>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
  <QuitCoHost
    :info="removeCoHostInfo"
    @quitCoHost="removeCoHost"
    />
  <QuitCoHost
    :info="removeReceivedCoHostInfo"
    @quitCoHost="removeReceivedCoHost"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Tools from '@/assets/js/utils.js'
import QuitCoHost from './quitCoHost.vue'
export default {
  components: {
    QuitCoHost
  },
  props: {
    changeRtmpType: String,
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    eventInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      State: (state) => state
    })
  },
  data () {
    return {
      rowInfo: {},
      userId: '',
      userIndex: '',
      removeCoHostInfo: {
        show: false,
        title: this.$t('coHost.reConfirmation'),
        contentText: this.$t('coHost.addCoHostRemove'),
        confirmText: true
      },
      removeReceivedCoHostInfo: {
        show: false,
        title: this.$t('coHost.reConfirmation'),
        contentText: this.$t('coHost.receivedRemove'),
        confirmText: true
      },
      selectType: 'invitedOther',
      cohostPageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      coHostSearchName: '',
      showErrorEmailText: false,
      cohostScroll: {
        distance: 10,
        onScroll: this.getCoHostHadInvite,
        loading: false
      },
      hadInviteCohost: [],
      options: [{
        value: '1',
        label: 'accept'
      }, {
        value: '2',
        label: 'declined'
      }],
      invitedMeList: [],
      receiverCohostPageInfo: {
        pageNum: 1,
        pageSize: 10,
        hasNextPage: false
      },
      receiverCohostScroll: {
        distance: 10,
        onScroll: this.getInvitedByOther,
        loading: false,
        directive: '.invitedMe .el-table__body-wrapper'
      }
    }
  },
  created () {
    // 打开弹窗后数据加载
    this.getCoHostHadInvite('init')
  },
  methods: {
    getInvitedList (tab) {
      if (!tab || tab.name === 'invitedOther' || this.selectType === 'invitedOther') {
        this.cohostPageInfo.pageNum = 1
        this.getCoHostHadInvite('init')
      } else {
        this.receiverCohostPageInfo.pageNum = 1
        this.getInvitedByOther('init')
      }
    },
    showReceivedPop () {
      this.$emit('showReceiverCoHost')
    },
    async getCoHostHadInvite (init) {
      if (!init && !this.cohostPageInfo.hasNextPage) return
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.cohostPageInfo.pageNum++
      this.cohostScroll.loading = true
      // 清空之前的状态
      this.coHostSearchName = ''
      this.showErrorEmailText = false
      const params = {
        invite: true,
        queryCollaborate: true,
        pageSize: this.cohostPageInfo.pageSize,
        pageNum: this.cohostPageInfo.pageNum
      }
      await this.$http
        .post('/commentator-backend/collaborate/queryV2', params)
        .then(res => {
          this.cohostScroll.loading = false
          const { errorCode, result } = res.data
          if (errorCode === '0x0') {
            this.cohostPageInfo.hasNextPage = result.hasNextPage
            if (this.cohostPageInfo.pageNum == 1) {
              const hadInviteArray = []
              result.list.forEach((info, index) => {
                info.color = this.returnColor(info)
                if (index < 3) {
                  hadInviteArray.push({
                    email: info.collaborateEmail.slice(0, 1),
                    color: info.color
                  })
                }
              })
              this.State.hadInvite = hadInviteArray
            }
            if (!init) {
              this.hadInviteCohost = this.hadInviteCohost.concat(result.list)
            } else {
              this.hadInviteCohost = result.list
            }
          } else {
            this.$message.warning(res.data.errorInfo)
          }
        })
    },
    returnColor (info) {
      const { status } = info
      if (status === 0 || status === 2) {
        return 'gray'
      } else if (status === 1) {
        return Tools.getEmailColor(info.collaborateEmail, this.State.avatarColor)
      }
    },
    // co-host点击保存
    saveCoHost (email) {
      if (!this.coHostSearchName) {
        this.$message.warning(this.$t('coHost.noInvitedEmail'))
        this.info.show = true
        return false
      }
      if (!this.isEmail(this.coHostSearchName)) return
      if (this.coHostSearchName === this.State.loginInfo.email) {
        this.$message.warning(this.$t('coHost.forbidSetting'))
        return
      }
      if (this.isHadInvited(this.coHostSearchName)) return
      const params = {
        collaborateUserEmailList: [this.coHostSearchName]
      }
      this.$http
        .post('/commentator-backend/collaborate', params, { errorTips: false })
        .then(res => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            if (email && this.coHostSearchName && this.isEmail(this.coHostSearchName) && !this.isHadInvited(this.coHostSearchName)) {
              const obj = {}
              obj.name = this.coHostSearchName
              obj.color = 'gray'
            }
            this.coHostSearchName = ''
            this.cohostPageInfo.pageNum = 1
            this.getCoHostHadInvite('init')
            this.$message.success(this.$t('coHost.hostSaveSuccess'))
            // 关闭弹窗
            // this.closeAdvanced()
          } else if (errorCode === '9000002') {
            this.$message.warning(this.$t('coHost.forbidSetting'))
          } else {
            this.$message.warning(res.data.errorInfo)
          }
        })
    },
    isEmail (val) {
      const regEmail = /^([\w+.-]*[+-]*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true
        this.$refs.emailInput.$el.children[0].focus()
        return false
      }
      return true
    },
    // 判断是否已经存在于列表中
    isHadInvited (email) {
      let flag = false
      // 统一输入的 email 地址为小写
      const lowerCaseEmail = email.toLowerCase()
      this.hadInviteCohost.forEach(info => {
        if (info.collaborateEmail.toLowerCase() === lowerCaseEmail && info.status != 2) {
          flag = true
        }
      })
      if (flag) {
        this.$message.warning(this.$t('coHost.hadInvited'))
      }
      return flag
    },
    // input格式校验
    checkInputText (val) {
      if (this.inputTimer) clearTimeout(this.inputTimer)
      const _this = this
      this.inputTimer = setTimeout(() => {
        const regEmail = /^([\w+.-]*[+-]*\.*)+@(\w-?)+(\.\w{2,})+$/
        if (val && !regEmail.test(val)) {
          this.showErrorEmailText = true
          _this.$refs.emailInput.$el.children[0].focus()
        } else {
          this.showErrorEmailText = false
        }
      }, 800)
    },
    removeCoHost () {
      const params = {
        userIds: [this.userId]
      }
      this.$http
        .delete('/commentator-backend/collaborate', { data: params })
        .then(res => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            this.cohostPageInfo.pageNum = 1
            this.getCoHostHadInvite('init')
            this.$message.success(this.$t('coHost.inviteDeleteSuccess'))
          } else {
            this.$message.warning(res.data.errorInfo)
          }
        })
    },
    deleteCohostInvite (userId, index) {
      this.removeCoHostInfo.show = true
      this.userId = userId
      this.userIndex = index
    },
    // <------------受邀请列表相关---------->
    getInvitedByOther (init) {
      if (!init && !this.receiverCohostPageInfo.hasNextPage) return
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.receiverCohostPageInfo.pageNum++
      const params = {
        invite: false,
        queryCollaborate: true,
        pageSize: this.receiverCohostPageInfo.pageSize,
        pageNum: this.receiverCohostPageInfo.pageNum
      }
      this.$http
        .post('/commentator-backend/collaborate/queryV2', params)
        .then(res => {
          const { errorCode, result } = res.data
          if (errorCode === '0x0') {
            this.receiverCohostPageInfo.hasNextPage = result.hasNextPage
            if (!init) {
              this.invitedMeList = this.invitedMeList.concat(result.list)
            } else {
              this.invitedMeList = result.list
            }
            result.list.forEach(item => {
              item.select = ''
              item.color = this.returnColor(item)
            })
          } else {
            this.$message.warning(res.data.errorInfo)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    controlPermission (val, rowInfo) {
      const params = {
        collaborateId: rowInfo.id,
        optionType: Number(val)
      }
      this.$http
        .post(`/commentator-backend/collaborate/updateStatusDirectly?collaborateId=${params.collaborateId}&optionType=${params.optionType}`, params)
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.invitedMeList.forEach(item => {
              if (item.id == rowInfo.id) {
                item.status = params.optionType
                item.color = this.returnColor({ status: params.optionType, collaborateEmail: item.userEmail })
              }
            })
            this.$message.success(this.$t('HostCommon.operateSucces'))
          }
        })
    },
    removeReceivedCoHost () {
      const params = {
        userIds: [this.rowInfo.userId],
        invite: false
      }
      this.$http
        .delete('/commentator-backend/collaborate', { data: params })
        .then(res => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            if (this.receiverCohostPageInfo.pageNum == 1 && this.receiverCohostPageInfo.hasNextPage) {
              this.getInvitedByOther('init')
            } else {
              this.invitedMeList.forEach((item, index) => {
                if (item.id == this.rowInfo.id) {
                  this.invitedMeList.splice(index, 1)
                }
              })
            }
            this.$message.success(this.$t('invite.inviteDeleteSuccess'))
          } else {
            this.$message.warning(res.data.errorInfo)
          }
        })
    },
    deleteCollaborateByOtherInvite (rowInfo) {
      this.removeReceivedCoHostInfo.show = true
      this.rowInfo = rowInfo
    },
    showInvitedTime (invitedTime) {
      const year = new Date(invitedTime).getFullYear()
      let month = new Date(invitedTime).getMonth() + 1
      let date = new Date(invitedTime).getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    returnText (rowInfo) {
      let _str = ''
      if (rowInfo.status == 0) {
        _str = this.$t('coHost.inviting')
      } else if (rowInfo.status == 1) {
        _str = this.$t('coHost.accept')
      } else {
        _str = this.$t('coHost.declined')
      }
      return _str
    },
    // 保存数据关闭弹窗
    closeAdvanced () {
      this.State.addCoHost = false
      this.info.show = false
      if (this.eventInfo.show) {
        this.$emit('openAssignCohost')
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog{
      border-radius: 8px;
    .el-dialog__header {
      .el-dialog__headerbtn {
        z-index: 1;
        .el-dialog__close {
          font-size: 16px;
          color: #28282e;
          font-weight: bold;
        }
        &:hover .el-dialog__close {
          color: #33AB4F;
        }
      }
    }
    .el-dialog__body {
      border: none;
      padding-top: 5px;
      margin-top: -20px;
      .inviteBox {
        margin-top: 15px;
        .loading-txt{
          color: rgb(144, 144, 144);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .userListBox {
          display: flex;
          align-items: center;
          padding: 7px 15px 7px 18px;
          .el-icon-user-solid{
            font-size: 23px;
          }
          .el-input {
            margin-right: 28px;
            margin-left: 28px;
          }
          .el-input__inner {
            border: none;
            color: #33ab4f;
            border-bottom: 2px solid #33ab4f;
          }
          .el-button {
            width: 85px;
            height: 36px;
            border-color: #33AB4F;
            background: #33AB4F;
            color: #fff;
            border-radius: 4px;
            &:hover {
              background: #0aa20a;
            }
          }

          .setEmailBox {
            padding-left: 34px;
            margin-top: 8px;
            .el-checkbox__input {
              .el-checkbox__inner {
                width: 18px;
                height: 18px;
                &::after {
                  height: 11px;
                  left: 6px;
                }
                &:hover {
                  border-color: #DCDFE6;
                }
              }
              &.is-checked {
                .el-checkbox__inner {
                  background: #0aa20a;
                  border-color: #0aa20a;
                }
                &+.el-checkbox__label {
                  color: gray;
                }
              }
            }
          }
        }
        .emailWarn {
            margin-left:67px;
          }
        .hadInviteList {
          margin-top: 15px;
          &::-webkit-scrollbar-thumb {
            background-color: #ccc;
            border-radius: 10px;
          }
            overflow-y: auto;
            height: 215px;
          .el-divider {
            background: #F5F5F5;
            &.el-divider--horizontal {
              margin: 7px 0;
            }
          }
          .li {
            margin-bottom: 10px;
            overflow: hidden;
            line-height: 32px;
            padding: 7px 15px 7px 15px;
            border-radius: 10px;
            &:hover {
              background: #F8F9FA;
              .el-icon-more {
                display: inline-block;
              }
            }
            .firstName {
              width: 32px;
              height: 32px;
              background: orange;
              border-radius: 50%;
              display: inline-block;
              text-align: center;
              line-height: 32px;
              font-size: 17px;
              margin-right: 14px;
              color: #fff;
            }
            .emailContent {
              display: inline-block;
              &.declined {
                text-decoration: line-through;
              }
            }
            .el-icon-more {
              display: none;
              margin-top: 9px;
            }
          }
        }
      }
      .el-input {

        &.redBorder {
          border: 1px solid red;
          border-radius: 3px;

          .el-input__inner {
            border: none;
          }
        }

        .el-input__inner {
          background: #f2f1f1fa;
          border-radius: 4px 4px 0 0;
          height: 40px;
          line-height: 40px;
        }
      }
      .el-tabs__active-bar {
        background: #33AB4F;
      }
      .el-tabs__item {
        font-size: 20px;

        &.is-active {
          color: #33AB4F;
        }

        &:hover {
          color: #33AB4F;
        }
      }
      .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
          border-bottom: 1px solid #EBEEF5!important;
      }
      .el-table::before{
          background:none;
        }
      .el-table.invitedMe {
          color:#606266;
        .ascending .sort-caret.ascending{
          border-bottom-color: #33ab4f;
        }
        .descending .sort-caret.descending{
            border-top-color: #33ab4f;
        }
        .el-icon-more {
          color:rgb(144,144,144);
        }
        td{
          border-bottom:1px solid #ebeef5 !important;
        }
        tbody tr{
          background-color: #fff !important;
        }
        tbody tr:hover{
          background-color: #F8F9FA !important;
        }
        .el-input {
        &.redBorder {
          border: 1px solid red;
          border-radius: 3px;

          .el-input__inner {
            border: none;
          }
        }

      .el-input__inner {
        background: #f2f1f1fa;
        border-radius: 4px 4px 0 0;
        height: 40px;
        line-height: 40px;
      }
    }
      .el-tabs__active-bar {
        background: #33ab4f;
      }
      .el-tabs__item {
        font-size: 20px;

        &.is-active {
          color: #33ab4f;
        }

        &:hover {
          color: #33ab4f;
        }
      }
      .el-table__body-wrapper {
        &::-webkit-scrollbar {
          height: 6px;
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 10px;
        }
        overflow-y: auto;
        height: 285px;
        .el-table__body {
          .el-table__cell {
            .cell {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              word-break: normal;

              .email {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                &.decline {
                  text-decoration: line-through;
                  color: #909090;
                }
              }

              &:nth-child(1) {
                text-overflow: initial;
              }

              .participant.firstName {
                width: 32px;
                height: 32px;
                background: orange;
                border-radius: 50%;
                display: inline-block;
                text-align: center;
                line-height: 32px;
                font-size: 17px;
                margin-right: 14px;
                color: #fff;

                &.green {
                  background: #0ca789;
                }

                &.orange {
                  background: #fac711;
                }

                &.purple {
                  background: #652cb3;
                }

                &.blue {
                  background: #2c9bf0;
                }

                &.gray {
                  background: #C1C1C1;
                }

                &.red {
                  background: #F6445A
                }
              }
            }

            &:nth-child(4) {
              span {
                color: #909090;

                &.pedding {
                  border: 1px solid #909090;
                  padding: 1px 2px;
                  border-radius: 2px;
                  display: inline-block;
                }
              }
              .el-select .el-input.is-focus .el-input__inner{
                border-color: #C0C4CC !important;
              }
              .el-select {
                margin-right: 0;
                width: 40%;

                .el-input__inner {
                  height: 0;
                  border:none;
                }

                .el-select__caret {
                  color: #0c6;
                  line-height: 23px !important;
                }
              }
            }

            &:nth-child(5) {
              .cell{
                display: flex;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }
}
</style>
